import api from './apiService';

export const getAllClients = async () => {
    try {
        const response = await api.get('/clients');
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const getActiveClients = async () => {
    try {
        const response = await api.get('/clients/active');
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const storeClient = async (data) => {
    try {
        const response = await api.post('/clients', data);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const updateClient = async (data) => {
    try {
        const response = await api.put('/clients', data);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const deleteClient = async (id) => {
    try {
        const response = await api.delete(`/clients/${id}`);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const getCategories = async () => {
    try {
        const response = await api.get('/clients/categories');
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const storeCategory = async (data) => {
    try {
        const response = await api.post('/clients/categories', data);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const updateCategory = async (data) => {
    try {
        const response = await api.put('/clients/categories', data);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const deleteCategory = async (id) => {
    try {
        const response = await api.delete(`/clients/categories/${id}`);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}